// D37.2: the dependency cause codes the API writes at the start of a readiness finding ("<code>: <details>"), shown in
// the reader's language with the English details kept (paths, versions, commands are not translated).
import type { Translate } from "../../i18n/index.tsx";
import type { MessageKey } from "../../i18n/en.ts";

export const DEPENDENCY_CAUSE_CODES = ["prepare_not_configured", "prepare_failed", "package_manager_missing", "registry_unreachable", "package_manager_fallback"] as const;
export type DependencyFindingCode = (typeof DEPENDENCY_CAUSE_CODES)[number];

const SEGMENT_RE = /^(prepare_not_configured|prepare_failed|package_manager_missing|registry_unreachable|package_manager_fallback): (.*)$/s;

/** `{ code, details }` of one finding, or null when the text does not start with a dependency code. */
export function parseDependencyFinding(segment: string): { code: DependencyFindingCode; details: string } | null {
  const m = SEGMENT_RE.exec(segment.trim());
  return m ? { code: m[1] as DependencyFindingCode, details: m[2] as string } : null;
}

/** One readiness finding in the reader's language when it carries a dependency code; null otherwise. */
export function dependencyCauseText(t: Translate, segment: string): string | null {
  const f = parseDependencyFinding(segment);
  if (!f) return null;
  return `${t(`deps.cause.${f.code}` as MessageKey)} — ${f.details}`;
}
